import React from 'react';
import { motion } from 'framer-motion';
export function BenefitsSection() {
  const benefits = [{
    title: 'Menos ansiedad',
    desc: 'Sabes qué buscar y qué hacer primero. El miedo disminuye cuando tienes información clara.'
  }, {
    title: 'Más claridad',
    desc: 'Información organizada y confiable, no búsquedas desesperadas en internet a las 3 de la mañana.'
  }, {
    title: 'Actúas con calma',
    desc: 'Tienes un plan paso a paso. No improvisas con la salud de tu pequeño.'
  }, {
    title: 'Algo concreto a la mano',
    desc: 'Abres tu guía y sigues los pasos. Sin dudas, sin pérdida de tiempo.'
  }];
  return <section className="py-20 bg-forest text-cream relative overflow-hidden" data-id="element-12">
      {/* Decorative background */}
      <div className="absolute top-0 left-0 w-full h-full opacity-5 pointer-events-none" data-id="element-13">
        <div className="absolute right-0 top-0 w-96 h-96 bg-cream rounded-full blur-3xl transform translate-x-1/2 -translate-y-1/2" data-id="element-14"></div>
        <div className="absolute left-0 bottom-0 w-96 h-96 bg-sage rounded-full blur-3xl transform -translate-x-1/2 translate-y-1/2" data-id="element-15"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-16">
        <div className="text-center mb-16" data-id="element-17">
          <h2 className="text-3xl md:text-4xl font-bold text-cream mb-6" data-id="element-18">
            Lo que cambia cuando tienes esta guía
          </h2>
          <div className="w-24 h-1 bg-terracotta mx-auto rounded-full" data-id="element-19"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-20">
          {benefits.map((benefit, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-forest-dark/50 backdrop-blur-sm p-8 rounded-2xl border border-sage/20 hover:border-terracotta/50 transition-colors duration-300" data-id="element-21">
              <h3 className="text-xl font-bold text-terracotta-light mb-3 font-serif" data-id="element-22">
                {benefit.title}
              </h3>
              <p className="text-cream/80 leading-relaxed" data-id="element-23">{benefit.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}